/**
 * @ticket TM-1000001727
 * Angular-Modul fuer das IN-Modul (Integration / Transfer).
 * P8a: Modul-Stub mit Entity-Provider-Registrierung.
 * P8b: Config-Page + Object-Pages fuer InIntegration und InTransferRun
 *      sowie Object-Components inkl. Config-Tabellen-Widget.
 */
import {NgModule} from '@angular/core';
import {IN_ENTITY_PROVIDER} from './in.entity-provider';
import {CoreModule} from '../../core/core.module';
import {InConfigPage} from './page/in-config/in-config.page';
import {
    InIntegrationObjectPage
} from './page/object/in-integration-object-page/in-integration-object.page';
import {
    InTransferRunObjectPage
} from './page/object/in-transfer-run-object-page/in-transfer-run-object.page';
// TM-1000001727: P8b — Object-Components + Config-Tabellen-Widget
import {
    InIntegrationObjectComponent
} from './component/object-components/in-integration-object-component/in-integration-object.component';
import {
    InTransferRunObjectComponent
} from './component/object-components/in-transfer-run-object-component/in-transfer-run-object.component';
import {
    InIntegrationTableComponent
} from './component/widgets/in-integration-table.component';

@NgModule({
    declarations: [
        // TM-1000001727: P8b — Pages
        InConfigPage,
        InIntegrationObjectPage,
        InTransferRunObjectPage,
        // TM-1000001727: P8b — Object-Components + Tabellen-Widget
        InIntegrationObjectComponent,
        InTransferRunObjectComponent,
        InIntegrationTableComponent,
    ],
    exports: [
        InConfigPage,
        InIntegrationObjectPage,
        InTransferRunObjectPage,
        InIntegrationObjectComponent,
        InTransferRunObjectComponent,
        InIntegrationTableComponent,
    ],
    imports: [
        CoreModule
    ],
    providers: [IN_ENTITY_PROVIDER]
})
export class InModule {
}
